import React from "react";
import Sidebar from "./Sidebar";

function SidebarLayout(props: SidebarLayoutProps) {
  return (
    <main className="relative min-h-screen flex">
      <Sidebar onPageChange={props.onPageChange} />
      <div
        className={`flex-1 min-w-0 p-7 bg-white-dark 2xl:p-10 ${
          props.fullWidth ? "" : "pr-20 2xl:pr-24"
        }`}
      >
        {props.children}
      </div>
    </main>
  );
}

export default SidebarLayout;

export type SidebarLayoutProps = {
  children: React.ReactNode;
  onPageChange?: (destination: string) => boolean;
  // Padding direito reduzido (igual aos outros lados) em vez do pr-20/
  // 2xl:pr-24 padrão — pensado pra telas de conteúdo denso tipo o
  // WhatsApp, onde aquele respiro extra (reservado originalmente pro
  // bolhão de chat flutuante) virava espaço em branco desperdiçado dos
  // dois lados do painel de conversa. Opt-in por página, não troca o
  // default pra não afetar telas de formulário que já contam com aquele
  // respiro.
  fullWidth?: boolean;
};
